import { showActionsModal } from './Modal.js';
import { showLessonQuiz } from './QuizModal.js';
import { showToast } from './Toast.js';
import { messageFor } from '../api/errors.js';
import { gameState } from '../state/gameState.js';

const PER_PAGE = 5;   // showActionsModal grows 64 px per row — 6 rows is the ceiling at 720 px.

// Topic picker (two pages of 5 + a nav row) → interactive lesson: the blurb, then every
// question of the topic answered like in the real test, with instant ✅/❌ feedback and
// the explanation (showLessonQuiz). `options[0]` is the correct answer in the lessons
// payload; the lesson shuffles the display order so the child can't just click the top row.
export async function showTheoryLessonsModal(scene) {
  // Fetched once per opening (~12 KB with the answers) instead of riding along in the
  // catalog on every state/action response — see backend routers/driving.py.
  let topicsById, lessons;
  try {
    ({ topics: topicsById, lessons } = await gameState.drivingLessons());
  } catch (e) {
    showToast(scene, messageFor(e));
    return;
  }
  let page = 0;
  for (;;) {
    const topics = Object.entries(topicsById);
    const pages = Math.ceil(topics.length / PER_PAGE);
    const slice = topics.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);
    const actions = slice.map(([id, t]) => ({ label: `${t.name_pl} (${lessons[id].length})`, fn: async () => id }));
    // Nav row keys start with a space so they can never collide with a topic id.
    if (page > 0) actions.push({ label: '{arrow_left} Wróć', fn: async () => ' back' });
    else if (pages > 1) actions.push({ label: 'Więcej {arrow_right}', fn: async () => ' more' });

    const picked = await showActionsModal(scene, {
      title: '{book} Lekcje teorii',
      body: `Wybierz temat (${page + 1} / ${pages})`,
      actions,
    });
    if (!picked || picked.error) return;
    if (picked === ' more') { page += 1; continue; }
    if (picked === ' back') { page -= 1; continue; }

    const t = topicsById[picked];
    const questions = lessons[picked].map((q) => {
      const order = q.options.map((_, j) => j).sort(() => Math.random() - 0.5);
      return { id: q.id, text: q.text, image: q.image, explanation: q.explanation,
        options: order.map((j) => q.options[j]), correctIdx: order.indexOf(0) };
    });
    await showLessonQuiz(scene, { title: t.name_pl, blurb: t.lesson, questions });
  }
}
